import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the type for a map item
export interface MapItem {
  id: string;
  page_id: string;
  map_data: any; // Using 'any' for flexibility, can be refined based on actual data structure
  created_at?: string;
  updated_at?: string;
}

// Define the state structure
interface MapsState {
  maps: MapItem[];
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: MapsState = {
  maps: [],
  loading: false,
  error: null
};

// Create the slice
const mapsSlice = createSlice({
  name: 'maps',
  initialState,
  reducers: {
    setMaps: (state, action: PayloadAction<MapItem[]>) => {
      state.maps = action.payload;
      state.loading = false;
      state.error = null;
    },
    setMapsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setMapsError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearMaps: (state) => {
      state.maps = [];
      state.loading = false;
      state.error = null;
    }
  }
});

// Export actions and reducer
export const { setMaps, setMapsLoading, setMapsError, clearMaps } = mapsSlice.actions;
export default mapsSlice.reducer;
